export * from './mtcAgentController.service';
import { MtcAgentControllerService } from './mtcAgentController.service';
export * from './mtcCustomerController.service';
import { MtcCustomerControllerService } from './mtcCustomerController.service';
export * from './mtcGsGeolocationController.service';
import { MtcGsGeolocationControllerService } from './mtcGsGeolocationController.service';
export * from './mtcNotesController.service';
import { MtcNotesControllerService } from './mtcNotesController.service';
export * from './mtcPricingController.service';
import { MtcPricingControllerService } from './mtcPricingController.service';
export * from './mtcTransferServiceController.service';
import { MtcTransferServiceControllerService } from './mtcTransferServiceController.service';
export const APIS = [MtcAgentControllerService, MtcCustomerControllerService, MtcGsGeolocationControllerService, MtcNotesControllerService, MtcPricingControllerService, MtcTransferServiceControllerService];
